export class ErrorLogModel {
  public componentName: string;
  public description: string;
  public eventDateTimeString: string;
  public logType: string = "";
  public instanceName: string;
  public instanceHashId: string = "";
  constructor() {}
}

export class ErrorLogFilterModel {
  public logTypes: string = "";
  public instanceHashId: string = "";
  public componentHashId: string = "";
  public StartDateTime: string;
  public EndDateTime: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/errorlog/models/errorlog.model.ts